import Section from '../Section';

export default class ImageWithTextSlideshow extends Section {

}
